const baseUrl = "https://4d-tjw.oss-cn-shenzhen.aliyuncs.com/uic/";

let data = {
  cjxz: [
    {
      image: baseUrl + "vr/23.png",
      en: "UIC Campus",
      url: "https://houseoss.4dkankan.com/uic/UICcode/hp1/tour.html",
      text: "北师港浸大校园",
    },
    // {
    //   image: baseUrl + "vr/24.png",
    //   en: "Proposed land for second phase campus construction",
    //   url: "https://houseoss.4dkankan.com/uic/UICcode/hp3/tour.html",
    //   text: "校园二期规划用地",
    // },
    {
      image: baseUrl + "vr/25.png",
      en: "Sports Park",
      url: "https://houseoss.4dkankan.com/uic/UICcode/hp2/tour.html",
      text: "体育公园",
    },
    {
      image: baseUrl + "vr/1.png",
      en: "Learning Resource Centre",
      url: "https://houseoss.4dkankan.com/uic/UICcode/zyzx/tour.html",
      text: "学习资源中心",
    },
    {
      image: baseUrl + "vr/2.png",
      en: "Ceramics Studio",
      url: "https://www.4dmodel.com/Frameinterface/spc.html?m=R4dzEiEE9",
      scene:true,
      text: "陶艺室"
    },
    {
      image: baseUrl + "vr/3.png",
      en: "Film and TV Studio",
      url: "https://www.4dmodel.com/Frameinterface/spc.html?m=cgyVWGclA",
      scene:true,
      text: "影视演播厅",
    },
    {
      image: baseUrl + "vr/4.png",
      en: "Yayue Hall",
      url: "https://www.4dmodel.com/Frameinterface/spc.html?m=nOdlRTUfy",
      scene:true,
      text: "雅乐堂",
      noMusic:true
    },
    {
      image: baseUrl + "vr/5.png",
      en: "House of Shedao",
      url: "https://www.4dmodel.com/Frameinterface/spc.html?m=uAgQegKmq",
      scene:true,
      text: "射道馆",
      noMusic:true
    },
    {
      image: baseUrl + "vr/6.png",
      en: "House of Guqin",
      url: "https://www.4dmodel.com/Frameinterface/spc.html?m=9yIk5LFO4",
      scene:true,
      text: "古琴馆",
      noMusic:true
    },
    {
      image: baseUrl + "vr/7.png",
      en: "Institute for Communication Studies of Chinese Culture",
      url: "https://www.4dmodel.com/Frameinterface/spc.html?m=tgX4MGneZ",
      scene:true,
      text: "中华文化传播研究院",
    },
    {
      image: baseUrl + "vr/8.png",
      en: "Accounting and Finance Research Laboratory",
      url: "https://www.4dmodel.com/Frameinterface/spc.html?m=0ruqoS84u",
      scene:true,
      text: "会计金融实验室",
    },
    {
      image: baseUrl + "vr/9.png",
      en: "Lecture Theatre",
      url: "https://houseoss.4dkankan.com/uic/UICcode/hyt/tour.html",
      text: "演讲厅",
    },
    {
      image: baseUrl + "vr/10.png",
      en: "Classroom",
      url: "https://houseoss.4dkankan.com/uic/UICcode/jiaoshi/tour.html",
      text: "教室",
    },
    {
      image: baseUrl + "vr/11.png",
      en: "Gym",
      url: "https://www.4dmodel.com/Frameinterface/smobile.html?m=bCLhG97U5",
      scene:true,
      text: "健身房",
    },
    {
      image: baseUrl + "vr/12.png",
      en: "Swimming Pool",
      url: "https://houseoss.4dkankan.com/uic/UICcode/yyc/tour.html",
      text: "游泳馆",
    },
    {
      image: baseUrl + "vr/13.png",
      en: "Multi-Purpose Gym",
      url: "https://houseoss.4dkankan.com/uic/UICcode/gym/tour.html",
      text: "多功能馆",
    },
    {
      image: baseUrl + "vr/14.png",
      en: "Dancing Room",
      url: "https://houseoss.4dkankan.com/uic/UICcode/wds/tour.html",
      text: "舞蹈室",
    },
    {
      image: baseUrl + "vr/15.png",
      en: "University Hall",
      url: "https://www.4dmodel.com/Frameinterface/spc.html?m=XUWwESDwc",
      scene:true,
      text: "大学会堂",
    },
    {
      image: baseUrl + "vr/16.png",
      en: "Laboratories",
      url: "https://www.4dmodel.com/Frameinterface/smobile.html?m=Z4Hz9nh10",
      scene:true,
      text: "实验室",
    },
    // {
    //   image: baseUrl + "vr/17.png",
    //   en: "Sports Park (ground)",
    //   url: "https://houseoss.4dkankan.com/uic/UICcode/tygy1/tour.html",
    //   text: "体育公园（地面）",
    // },
    {
      image: baseUrl + "vr/18.png",
      en: "Student Dormitory (Double Room)",
      url: "https://www.4dmodel.com/Frameinterface/spc.html?m=aUYeNAvVk",
      scene:true,
      text: "宿舍（二人间）",
      noMusic:true
    },
    {
      image: baseUrl + "vr/19.png",
      en: "Student Dormitory (Triple Room)",
      url: "https://houseoss.4dkankan.com/uic/UICcode/sanrenjian/tour.html",
      text: "宿舍（三人间）",
    },
    {
      image: baseUrl + "vr/20.png",
      en: "Student Dormitory (Quadruple Room)",
      url: "https://houseoss.4dkankan.com/uic/UICcode/sirenjian/tour.html",
      text: "宿舍（四人间）",
    },
    {
      image: baseUrl + "vr/21.png",
      en: "Common Room of Student Dormitory",
      url: "https://www.4dmodel.com/Frameinterface/smobile.html?m=4WMcIdrFQ",
      scene:true,
      text: "宿舍公共空间",
      noMusic:true
    },
    // {
    //   image: baseUrl + "vr/22.png",
    //   en: "Canteens",
    //   url: "https://www.4dmodel.com/Frameinterface/spc.html?m=AqFvVacEw",
    //   scene:true,
    //   text: "餐厅",
    // },
  ],
};

let all = [];

Object.keys(data).forEach((item) => {
  data[item][0]["isfirst"] = true;
  data[item][data[item].length - 1]["isLast"] = true;
  all = data[item].concat(all);
});

export { data };
